import React, { useEffect, useState } from 'react';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomButton from '../../../../../components/CustomButton';
import CustomCol from '../../../../../components/CustomCol';
import CustomRow from '../../../../../components/CustomRow';
import Input from '../../../../../components/InputNew';
import Select from '../../../../../components/InputNew/Select';
import Log from '../../../../../components/Log/Log';
import Modal from '../../../../../components/Modal';
import Tabela from '../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { useStatusTedPlanoAcao } from '../../../../../services/enum/useStatusPlanoAcaoTED';
import { isHttpError } from '../../../../../services/httpClient';
import {
  createPlanoAcao,
  deleteDeletePlanoAcao,
  getPlanosAcaoPorTed,
  updatePlanoAcao,
} from '../../../../../services/teds/tedsPlanoAcaoService';
import theme from '../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDate,
  formatDateSimp,
} from '../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../utils/swal';
import { TedPlanoTrabalho } from '../planoTrabalho';
import {
  headersPlanoAcao,
  valoresExibidosPlanoAcao,
} from './auxiliarPlanoAcao';
import CustomOffcanvas from '../../../../../components/CustomOffcanvas';

interface Props {
  id_ted: number;
  componente: string;
}

type FormTedPlanoAcaoType = {
  id: number;
  tedId: number;
  status: number;
  nupSei: string;
  numeroPa: string;
  documentoSei: string;
  dataInicio: string;
  dataTermino: string;
  objetivo: string;
  justificativa: string;
  observacoes: string;
  nPlanosTrabalho: number;
  nProdutosDaf: number;
  valorTotal: number;
};

export const TedPlanoAcao: React.FC<Props> = ({ id_ted, componente }) => {
  const statusOptions = useStatusTedPlanoAcao();

  //////STATES
  const [showModal, setShowModal] = useState(false);
  const [logData, setLogData] = useState<any>();
  const [planoAcaoId, setPlanoAcaoId] = useState('');

  const [updating, setUpdating] = useState(false);
  const [statusPlanoAcaoStyle, setStatusPlanoAcaoStyle] =
    useState<React.CSSProperties>({});
  const [dataPlanosAcao, setDataPlanosAcao] = useState<any[]>();
  const [formPlanoAcao, setFormPlanoAcao] = useState<FormTedPlanoAcaoType>({
    id: 0,
    tedId: id_ted,
    status: 0,
    nupSei: '',
    numeroPa: '',
    documentoSei: '',
    dataInicio: '',
    dataTermino: '',
    objetivo: '',
    justificativa: '',
    observacoes: '',
    nPlanosTrabalho: 0,
    nProdutosDaf: 0,
    valorTotal: 0,
  });

  //////FETCH DATA
  const fetchData = async () => {
    try {
      const planosAcao = await getPlanosAcaoPorTed(String(id_ted));

      setDataPlanosAcao(planosAcao);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id_ted]);

  //////USE EFFECT
  useEffect(() => {
    const emElaboracao = theme.colors.amarelogov;
    const emExecucao = theme.colors.verdegov;
    const finalizado = theme.colors.cinzaEscuro;
    const suspenso = '#ff4646';
    const cancelado = '#9c0c0c';

    const status = Number(formPlanoAcao.status);

    const newStatusStyle = {
      backgroundColor:
        status === 1
          ? emElaboracao
          : status === 2
            ? emExecucao
            : status === 3
              ? finalizado
              : status === 4
                ? suspenso
                : status === 5
                  ? cancelado
                  : 'white',
      color: status === 0 ? 'black' : 'white',
    };
    setStatusPlanoAcaoStyle(newStatusStyle);
  }, [formPlanoAcao.status]);

  useEffect(() => {
    const { dataInicio, dataTermino } = formPlanoAcao;

    if (dataInicio && dataTermino && dataTermino < dataInicio) {
      const verificarDatas = async () => {
        await swalAttention(
          `A <b>data de término ${formatDateSimp(dataTermino)}</b> não pode ser inferior à <b>data de início ${formatDateSimp(dataInicio)}</b>.`,
        );

        setFormPlanoAcao((prev) => ({
          ...prev,
          dataTermino: '',
        }));
      };

      verificarDatas();
    }
  }, [formPlanoAcao.dataInicio, formPlanoAcao.dataTermino]);

  useEffect(() => {
    const { dataInicio, dataTermino } = formPlanoAcao;

    if (dataInicio && dataTermino) {
      const dtInicio = new Date(dataInicio);
      const dtTermino = new Date(dataTermino);

      if (dtTermino < dtInicio) {
        setFormPlanoAcao((prev) => ({
          ...prev,
          dataTermino: '',
        }));
        swalAttention(
          `A data de <b>TÉRMINO</b> ${formatDateSimp(dataTermino)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>INÍCIO</b> ${formatDateSimp(dataInicio)}.`,
        );
      }
    }
  }, [formPlanoAcao.dataInicio, formPlanoAcao.dataTermino]);

  const [isDataActive, setIsDataActive] = useState(false);
  useEffect(() => {
    if (Number(formPlanoAcao.status) > 1) {
      setIsDataActive(true);
    } else {
      setIsDataActive(false);
    }
  }, [formPlanoAcao.status]);

  //////TABLE E OFFCANVAS
  const tableData =
    dataPlanosAcao
      ?.slice() // faz uma cópia para não mutar o array original
      .sort(
        (a, b) =>
          new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime(),
      )
      .map((item) => {
        // Definindo cores de fundo com base no status do documento
        let statusBackgroundColor = '';
        let colorText = 'black';

        const statusLabel = statusOptions[item.status].label;

        if (statusLabel === 'Em Elaboração') {
          statusBackgroundColor = theme.colors.amarelogov;
          colorText = 'white';
        } else if (statusLabel === 'Em Execução') {
          statusBackgroundColor = theme.colors.verde;
          colorText = 'white';
        } else if (statusLabel === 'Encerrado') {
          statusBackgroundColor = theme.colors.cinzaEscuro;
          colorText = 'white';
        } else if (statusLabel === 'Suspenso') {
          statusBackgroundColor = theme.colors.laranja;
          colorText = 'white';
        } else if (statusLabel === 'Cancelado') {
          statusBackgroundColor = theme.colors.vermelho;
          colorText = 'white';
        }

        return {
          id: item.id,
          status: (
            <span
              style={{
                backgroundColor: statusBackgroundColor,
                color: colorText,
                borderRadius: '10px',
                padding: '12px',
                display: 'inline-block',
                minWidth: '100px',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {statusLabel}
            </span>
          ),
          numeroPa: item.numeroPa,
          documentoSei: item.documentoSei,
          dataInicio: item.dataInicio ? formatDateSimp(item.dataInicio) : '',
          dataTermino: item.dataTermino ? formatDateSimp(item.dataTermino) : '',
          nPlanosTrabalho: (
            <div style={{ textAlign: 'right' }}>
              {formatarNumero(item.nPlanosTrabalho)}
            </div>
          ),
          nProdutosDaf: (
            <div style={{ textAlign: 'right' }}>
              {formatarNumero(item.nProdutosDaf)}
            </div>
          ),
          valorTotal: (
            <div style={{ textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTotal)}
            </div>
          ),
        };
      }) || [];

  const offCanvasData =
    dataPlanosAcao?.map((item) => {
      // Definindo cores de fundo com base no status do documento
      let statusBackgroundColor = '';
      let colorText = 'black';

      const statusLabel = statusOptions[item.status].label;

      if (statusLabel === 'Em Elaboração') {
        statusBackgroundColor = theme.colors.amarelogov;
        colorText = 'white';
      } else if (statusLabel === 'Em Execução') {
        statusBackgroundColor = theme.colors.verde;
        colorText = 'white';
      } else if (statusLabel === 'Encerrado') {
        statusBackgroundColor = theme.colors.cinzaEscuro;
        colorText = 'white';
      } else if (statusLabel === 'Suspenso') {
        statusBackgroundColor = theme.colors.laranja;
        colorText = 'white';
      } else if (statusLabel === 'Cancelado') {
        statusBackgroundColor = theme.colors.vermelho;
        colorText = 'white';
      }

      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        status: (
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              color: colorText,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '100px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {statusLabel}
          </span>
        ),
        numeroPa: item.numeroPa,
        documentoSei: item.documentoSei,
        dataInicio: item.dataInicio
          ? formatDateSimp(item.dataInicio)
          : 'Não informado',
        dataTermino: item.dataTermino
          ? formatDateSimp(item.dataTermino)
          : 'Não informado',
        objetivo: item.objetivo,
        justificativa: item.justificativa,
        separadorValores: '',
        nPlanosTrabalho: (
          <div style={{ textAlign: 'right' }}>
            {formatarNumero(item.nPlanosTrabalho)}
          </div>
        ),
        nProdutosDaf: (
          <div style={{ textAlign: 'right' }}>
            {formatarNumero(item.nProdutosDaf)}
          </div>
        ),
        valorTotal: (
          <div style={{ textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorTotal)}
          </div>
        ),
        separadorObservacoes: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setFormPlanoAcao({
      id: 0,
      tedId: id_ted,
      status: 0,
      nupSei: '',
      numeroPa: '',
      documentoSei: '',
      dataInicio: '',
      dataTermino: '',
      objetivo: '',
      justificativa: '',
      observacoes: '',
      nPlanosTrabalho: 0,
      nProdutosDaf: 0,
      valorTotal: 0,
    });
    setLogData({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClickPlanoAcao = (id: string) => {
    setPlanoAcaoId(id);
    setUpdating(true);
    setShowModal(true);

    const itemSelecionado = dataPlanosAcao?.find((d) => d.id === id);
    if (itemSelecionado) {
      const formatDateLocal = (iso: string) => iso?.split('T')[0];
      setFormPlanoAcao({
        id: Number(itemSelecionado.id),
        tedId: Number(itemSelecionado.tedId),
        status: Number(itemSelecionado.status),
        nupSei: itemSelecionado.nupSei,
        numeroPa: itemSelecionado.numeroPa,
        documentoSei: itemSelecionado.documentoSei,
        dataInicio: itemSelecionado.dataInicio
          ? formatDateLocal(itemSelecionado.dataInicio)
          : '',
        dataTermino: itemSelecionado.dataTermino
          ? formatDateLocal(itemSelecionado.dataTermino)
          : '',
        objetivo: itemSelecionado.objetivo,
        justificativa: itemSelecionado.justificativa,
        observacoes: itemSelecionado.observacoes,
        nPlanosTrabalho: itemSelecionado.nPlanosTrabalho,
        nProdutosDaf: itemSelecionado.nProdutosDaf,
        valorTotal: itemSelecionado.valorTotal,
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    // Campos que devem ser convertidos para número
    const camposNumericos = ['tipoFiscal', 'idUsuarioFiscal'];

    setFormPlanoAcao((prev: FormTedPlanoAcaoType) => ({
      ...prev,
      [name]: camposNumericos.includes(name) ? parseInt(value, 10) : value,
    }));
  };

  const handleCreatePlanoAcao = async () => {
    try {
      if (!validateForm(formPlanoAcao)) throw new Error('Formulário inválido.');
      const formToSend = {
        ...formPlanoAcao,
        dataInicio: formPlanoAcao.dataInicio || null,
        dataTermino: formPlanoAcao.dataTermino || null,
        status: Number(formPlanoAcao.status),
      };
      await createPlanoAcao(formToSend);
      swalSave();
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(formPlanoAcao)) throw new Error('Formulário inválido.');
      const formToSend = {
        ...formPlanoAcao,
        dataInicio: formPlanoAcao.dataInicio || null,
        dataTermino: formPlanoAcao.dataTermino || null,
        status: Number(formPlanoAcao.status),
      };

      const response = await updatePlanoAcao(planoAcaoId, formToSend);
      swalAtualizacao('Sucesso', response.data.message);
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await deleteDeletePlanoAcao(planoAcaoId);
      swalDeleteConfirm();
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //////OUTRAS FUNÇÕES
  const validateForm = (form: any) => {
    const errors = [];
    if (!form.status) errors.push('<b>Status</b> é obrigatório.');
    if (!form.numeroPa)
      errors.push('<b>Nº do Plano de Ação</b> é obrigatório.');

    if (Number(form.status) > 1) {
      if (!form.dataInicio) {
        errors.push('<b>Data Início</b> é obrigatório.');
      }

      if (!form.dataTermino) {
        errors.push('<b>Data Término</b> é obrigatório.');
      }
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }
    return true;
  };

  return (
    <BoxConteudo boxTitulo="Planos de Ação do TED">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersPlanoAcao}
            dataTable={tableData}
            displayValues={valoresExibidosPlanoAcao}
            onRowClick={handleRowClickPlanoAcao}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
            mostrarBotaoCopiar={false}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdating(false);
            handleClickInserirNovo();
          }}
          disabled={Number.isNaN(id_ted)}
        />
      </CustomCol>

      {/* Modal/*/}
      <CustomOffcanvas
        title="Plano de Ação"
        show={showModal}
        onClose={handleShowModal}
        width="70vw"
      >
        <WorkspaceFicha>
          {Number(formPlanoAcao.id) > 0 ? (
            <Log
              {...logData}
              entity="TB_TED_PLANO_ACAO"
              id={Number(formPlanoAcao.id)}
            />
          ) : null}

          <BoxConteudo boxTitulo="Identificação do Plano de Ação">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="190px">
                <Select
                  name="status"
                  value={formPlanoAcao.status}
                  options={statusOptions}
                  onChange={handleChange}
                  label="Status"
                  style={statusPlanoAcaoStyle}
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="numeroPa"
                  name="numeroPa"
                  label="Nº do Plano de Ação"
                  value={formPlanoAcao.numeroPa}
                  type="text"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="160px">
                <Input
                  id="documentoSei"
                  name="documentoSei"
                  label="Nº Documento SEI"
                  value={formPlanoAcao.documentoSei}
                  type="text"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol width="185px">
                <Input
                  id="dataInicio"
                  name="dataInicio"
                  label="Início da Vigência"
                  value={formPlanoAcao.dataInicio}
                  type="date"
                  onChange={handleChange}
                  required={isDataActive}
                />
              </CustomCol>
              <CustomCol width="185px">
                <Input
                  id="dataTermino"
                  name="dataTermino"
                  label="Fim da Vigência"
                  value={formPlanoAcao.dataTermino}
                  type="date"
                  onChange={handleChange}
                  required={isDataActive}
                />
              </CustomCol>
              <CustomCol width="120px">
                <Input
                  name="link"
                  label="Planos Trab."
                  value={formPlanoAcao.nPlanosTrabalho}
                  id="tagVersao"
                  type="integer"
                  onChange={handleChange}
                  readonly
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol width="120px">
                <Input
                  name="link"
                  label="Nº Produtos"
                  value={formPlanoAcao.nProdutosDaf}
                  id="tagVersao"
                  type="integer"
                  onChange={handleChange}
                  readonly
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol width="175px">
                <Input
                  name="link"
                  label="Valor Total R$"
                  value={formatarValorFormatoDinheiro(formPlanoAcao.valorTotal)}
                  id="tagVersao"
                  type="integer"
                  onChange={handleChange}
                  readonly
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  id="objetivo"
                  name="objetivo"
                  label="Objetivo"
                  value={formPlanoAcao.objetivo}
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="justificativa"
                  name="justificativa"
                  label="Justificativa/Motivação"
                  value={formPlanoAcao.justificativa}
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
            <BarraInferiorBotoes>
              {updating ? (
                <WorkspaceBotoes
                  delete
                  // deleteDisabled={btDisable}
                  onClickDelete={handleDelete}
                  save
                  // saveDisabled={btDisable}
                  onClickSave={handleUpdate}
                />
              ) : (
                <WorkspaceBotoes
                  inserir
                  // inserirDisabled={btDisable}
                  onClickInserir={handleCreatePlanoAcao}
                />
              )}
            </BarraInferiorBotoes>
          </BoxConteudo>

          {/* Plano de Trabalho */}

          {Number(formPlanoAcao.id) > 0 ? (
            <TedPlanoTrabalho
              novoRegistro={Number(planoAcaoId) == 0 ? false : true}
              componente={Number(componente)}
              idPlanoAcao={Number(planoAcaoId)}
              planoAcaoLabel={formPlanoAcao.numeroPa}
            ></TedPlanoTrabalho>
          ) : null}
        </WorkspaceFicha>
      </CustomOffcanvas>
    </BoxConteudo>
  );
};
